<template>    
   <BaseModal
        :id="'static-update'"
        :title="title"
        :message="'<b>Note:</b> When creating a note, by default, it will be visible to all team members who report directly to you. You can use the <b>Display to</b> field to send notes to an individual team member who reports to you.'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_local_update(single_object.id, global_index)">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="single_object"
                    :array_options="array_options"
                    :for_update="true"
                    v-on:selectOption="selectOption($event)"
                    v-on:removeOption="removeOption($event)"
                />
                <div :class="'col-md-12'" class="p-0 formdynamic__item" v-if="single_object.date_method === 1 || single_object.date_method === 2">
                    <div class="formdynamic__item__field">
                        <label v-html="`${single_object.date_method === 1 ? 'Days' : 'Hours'}: ${single_object.date_method === 1 || single_object.date_method === 2 ? `<b style='color:red;'>*</b>` : ''}`" class="modal-label"/>
                        <input
                            :placeholder="''"
                            :disabled="false"
                            :type="'number'" 
                            :required="single_object.date_method === 1 || single_object.date_method === 2 ? true : false"
                            v-model="single_object.numeric_time_drop"
                        />
                    </div>
                </div>
                <FormDynamic
                    :form_format="form_format_3"
                    :form_data="single_object"
                    :array_options="[]"
                    :for_update="false"
                />

                <CentralButtons />
            </form>
        </template>
    </BaseModal>
</template>

<script>

import NoteFormResources from './note_form_resources'
import FormDynamic from '@/components/FormDynamic.vue'
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal from '@/components/BaseModal'
import CentralButtons from '@/components/CentralButtons'

export default {

    name:   'NoteUpdateModal',
    props: [
        'title',
        'rest_api',
        'notyf',
        'single_object',
        'global_index',
        "array_options",
        "breadcrumb",
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    watch: {
        'single_object.numeric_time_drop'(val)
        {
            if (val <= 0)
            {
                this.single_object.numeric_time_drop = 1
            }
            else if (val >= 100)
            {
                this.single_object.numeric_time_drop = 100
            }
        }
    },

    data(){
        return{
            form_format: NoteFormResources.form_format_lite,
            form_format_3: NoteFormResources.form_format_3,
        }
    },
    
    methods:{
        mountUpdate()
        {
            setTimeout(() => {
                this.single_object.associate_id.forEach((item, index) => {
                    let index2 =this.array_options.associate_id.findIndex(option => option.id === item)
                    if(index2 <= -1)
                    {
                        this.single_object.associate_id.splice(index, 1)
                    }
                })

                if(this.single_object.associate_id.length === (this.array_options.associate_id.length - 1))
                {
                    this.single_object.associate_id.push(0)
                }

            }, 250);  
        },
        form_submit_local_update(object_id, object_index)
        {
            var index = this.single_object.associate_id.indexOf(0);
            if (index !== -1) 
            {
                this.single_object.associate_id.splice(index, 1);
            }
            this.form_submit_update(object_id,object_index)

        },
        selectOption(event)
        {
            setTimeout(() => {
                if(event === 0)
                {
                    this.single_object.associate_id = this.array_options.associate_id.map(associate => associate.id)
                }
                else
                {
                    if(this.single_object.associate_id.length === (this.array_options.associate_id.length - 1))
                    {
                        this.single_object.associate_id.push(0)
                    }

                }
                
            }, 250);   
        },
        removeOption(event)
        {
            setTimeout(() => {
                if(event === 0)
                {
                    this.single_object.associate_id = []
                }
                else
                {
                    if(this.single_object.associate_id.length < this.array_options.associate_id.length)
                    {
                        var index = this.single_object.associate_id.indexOf(0);
                        if (index !== -1) 
                        {
                            this.single_object.associate_id.splice(index, 1);
                        }

                    }
                }
            }, 250);
        }

    },

    mounted(){

    }
    
}
</script>